import React, { useEffect } from "react";
import { X } from "lucide-react";

/**
 * Full-screen editor overlay — keeps edit forms in view instead of below long tables.
 */
const AdminEditorModal = ({ open, title, subtitle, onClose, children, footer }) => {
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[12000] flex items-center justify-center p-3 sm:p-4 bg-slate-900/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-editor-modal-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="flex flex-col w-full max-w-5xl max-h-[92vh] rounded-2xl bg-white border border-slate-200 shadow-2xl overflow-hidden">
        <div className="shrink-0 flex items-start justify-between gap-3 px-4 sm:px-5 py-4 border-b border-slate-200 bg-white">
          <div className="min-w-0">
            <h3 id="admin-editor-modal-title" className="text-lg font-semibold text-[#011337] truncate">
              {title}
            </h3>
            {subtitle ? <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p> : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-slate-300 text-sm text-slate-700 hover:bg-slate-50"
            aria-label="Close editor"
          >
            <X size={16} />
            Close
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 sm:px-5 py-4">{children}</div>

        {footer ? (
          <div className="shrink-0 px-4 sm:px-5 py-3 border-t border-slate-200 bg-slate-50 flex flex-wrap items-center justify-end gap-2">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AdminEditorModal;
